import React, { useEffect, useRef, useState } from 'react';
import 'leaflet/dist/leaflet.css';
import L, { LatLngExpression, curve } from "leaflet";
import '@elfalem/leaflet-curve';
import Dashboard from './components/Dashboard';  // Import the Dashboard component
import { getAirportsData, findAirportByIATA, findDashboardData, findRoutes, getCurvedMidLatLongPoint } from './services/UtilityService'; // Import utility functions
import { DataService } from './services/DataService';
import { ConfigSettings } from './config/ConfigSettings';
import SearchResults from './components/SearchResults';
import { openRightPanel, hideLeftPanel, openLeftPanel } from './services/UIServices';
import FlightDetails from './components/FlightDetails';

const MapWithAirRoute = () => {
  const mapRef = useRef(null);
  // Initialize state for dashboard data
  const [dashboardData, setDashboardData] = useState({});
  const [selectedRoute, setSelectedRoute] = useState([]);
  const [flightInformation, setFlightInformation] = useState([]);
  // const [filterInfo, setFilterInfo] = useState({});

  var map = null;
  var jsondata = [];
  var airportsOrg = {};
  var airportsDe = {};
  var filterInfo = {};
  useEffect(() => {
    document.getElementById('b_header').style.setProperty('height', '96px')
    if (mapRef.current !== null) {
      return;
    }
    initMap();
    fetchAndDrawRoute();

  }, []);

  const initMap = () => {
    var container = L.DomUtil.get('map');
    if (container != null) { container._leaflet_id = null; }
    map = L.map('map');//.setView([51.505, -0.09], 3);
    map.doubleClickZoom.disable();
    // map.dragging.disable();
    map.scrollWheelZoom.disable();
    mapRef.current = map;

    // Add tile layer


    // var OpenStreetMap_CAT = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}', {
    // });
    // OpenStreetMap_CAT.addTo(map);
    // var Stadia_StamenTonerLabels = L.tileLayer('https://tiles.stadiamaps.com/tiles/stamen_toner_labels/{z}/{x}/{y}{r}.png', {
    // }).addTo(map);
    // var Stadia_StamenTerrainLines = L.tileLayer('https://tiles.stadiamaps.com/tiles/stamen_terrain_lines/{z}/{x}/{y}{r}.{ext}', {
    //   ext: 'png'
    // }).addTo(map);
    L.tileLayer(ConfigSettings.MapSettings.URL_TEMPLATE_TITLE, {
      attribution: '&copy; OpenStreetMap contributors',
    }).addTo(map);

  }

  const addMarkersToLocations = (originCoords, layoverCoords, destinationCoords) => {
    const originIcon = L.icon({
      iconUrl: require('../src/assets/images/marker-icon.png'), // Replace with your custom icon URL
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    });
    L.marker(originCoords, { icon: originIcon }).addTo(map).bindPopup(airportsOrg.City + " (Origin)").bindTooltip(airportsOrg.City + " (Origin)").openTooltip();
    // console.log(layoverCoords)
    layoverCoords.forEach((lay, index) => {
      lay.map((coords) => {
        L.marker([coords.Latitude, coords.Longitude], { icon: originIcon })
          .addTo(map).bindTooltip(`Layover ${index + 1} ${coords.Code}`);//.openTooltip();
      });
    });

    L.marker(destinationCoords, { icon: originIcon }).addTo(map).bindPopup(airportsDe.City + " (Destination)").bindTooltip(airportsDe.City + " (Destination)").openTooltip();
  }
  var allPaths = [];

  const fetchAndDrawRoute = async () => {
    try {
      jsondata = await new DataService().getTestData();
      var _dashboardData = findDashboardData(jsondata);
      // console.log("dashboardData", _dashboardData);
      setDashboardData(_dashboardData);
      // Extract origin and destination from JSON
      const origin = jsondata.OriginLocation;
      const destination = jsondata.DestinationLocation;

      var originCoords = [];
      var destinationCoords = [];

      airportsOrg = await findAirportByIATA(origin);
      // console.log(airportsDe)
      originCoords = [parseFloat(airportsOrg.Latitude), parseFloat(airportsOrg.Longitude)];

      airportsDe = await findAirportByIATA(destination);
      destinationCoords = [parseFloat(airportsDe.Latitude), parseFloat(airportsDe.Longitude)];

      var layoverLocationCodes = await findRoutes(origin, destination);
      if (filterInfo != null && filterInfo.stopscount != null && filterInfo.stopscount.length > 0) {
        var tc = [];
        filterInfo.stopscount.forEach(x => {
          return layoverLocationCodes.forEach(y => {
            if ((x == '0' && (y == null || y.length == 0))
              || (x == '1' && y.length == 1)
              || (x == '2' && y.length == 2)
              || (x == '2+' && y.length > 2)) {
              tc.push(y);
            }
          })
        })
        layoverLocationCodes = tc;
      }
      console.log(layoverLocationCodes)
      var layoverCoords = [];
      for (var i = 0; i < layoverLocationCodes.length; i++) {
        var airportLayover = [];
        for (var j = 0; j < layoverLocationCodes[i].length; j++) {
          var t = layoverLocationCodes[i][j];
          var rData = await findAirportByIATA(t);
          var obj = { Code: t, City: rData.City, Latitude: parseFloat(rData.Latitude), Longitude: parseFloat(rData.Longitude) };
          airportLayover.push(obj);
        }
        layoverCoords.push(airportLayover)
      }
      // layoverCoords = layoverCoords.filter(x => x != null);
      // console.log(originCoords, layoverCoords, destinationCoords)

      addMarkersToLocations(originCoords, layoverCoords, destinationCoords);

      var _animate = {};
      _animate = {
        duration: 5000,
        iterations: 1,
        easing: 'ease-in-out',
        // direction: 'alternate'
      }
      allPaths = layoverCoords.map((l, index) => {
        // var _tp = [];
        var origin, destination;
        l.splice(0, 0, { Code: airportsOrg.IATA_FAA, City: airportsOrg.City, Latitude: originCoords[0], Longitude: originCoords[1] })
        l.push({ Code: airportsDe.IATA_FAA, City: airportsDe.City, Latitude: destinationCoords[0], Longitude: destinationCoords[1] })
        var _curvePath = [];//['M', origin, 'Q', midLatLong, destination]
        _curvePath.push('M');
        _curvePath.push(originCoords);
        _curvePath.push('Q');
        l.map((layCoords, i) => {
          if (i > 0) {
            origin = [l[i - 1].Latitude, l[i - 1].Longitude];
            destination = [layCoords.Latitude, layCoords.Longitude]
            var midLatLong = getCurvedMidLatLongPoint(origin, destination);
            // console.log(layCoords)
            // _tp.push(['M', origin, 'Q', midLatLong, destination])
            _curvePath.push(midLatLong);
            _curvePath.push(destination);

          }
        })
        return {
          paths: _curvePath,
          options: {
            color: ConfigSettings.MapSettings.PathSettings.Colors[index], weight: 3, opacity: 0.7, animate: _animate
          },
          message: `Route from ${airportsOrg.City} to ${airportsDe.City} via Layover ${index + 1}`,
          planeInfo: {
            origin: airportsOrg.City,
            destination: airportsDe.City,
            originCode: airportsOrg.IATA_FAA,
            destinationCode: airportsDe.IATA_FAA,
            layovers: l
          }
        };
      });

      console.log(allPaths);
      // Add curves to the map dynamically
      allPaths.forEach((pathData) => {
        //paths.forEach((path) => {
        // console.log(path, options)
        const _curve = curve(pathData.paths, pathData.options).addTo(map);
        // var coordinateArray = _curve.getLatLngs();
        // console.log('coordinateArray', coordinateArray)
        _curve.on('click', () => handleCurveClick(pathData.planeInfo, pathData.message));  // Handle click event
        //});
      });
      // Fit the map to show both origin and destination
      // var tempData = [];
      // // tempDate.push({ Latitude: originCoords[0], Longitude: originCoords[1].Longitude })
      // // tempDate.push({ Latitude: destinationCoords[0], Longitude: destinationCoords[1].Longitude })
      // layoverCoords.forEach(x => x.map(y => {
      //   if (tempData.filter(t => t.Longitude == y.Longitude && t.Latitude == y.Latitude).length <= 0)
      //     tempData.push(y)
      // }));
      // var _sw = tempData.soryArray('Latitude')[0]
      // var _nE = tempData.soryArray('Longitude')[0]
      // const bounds = L.latLngBounds([[_sw.Latitude, _sw.Longitude], [_nE.Latitude, _nE.Longitude]]);
      const bounds = L.latLngBounds([originCoords, destinationCoords]);
      map.fitBounds(bounds);
      setSelectedRoute({
        origin: airportsOrg.City,
        destination: airportsDe.City,
        originCode: airportsOrg.IATA_FAA,
        destinationCode: airportsDe.IATA_FAA
      })
      openRightPanel();
    } catch (error) {
      console.error("Error drawing the route:", error);
    }
  }

  const handleCurveClick = (planeInfo, message) => {
    // alert(message);// Optional alert
    // Update the dashboard data when curve is clicked
    console.log(planeInfo);
    setSelectedRoute(planeInfo);
    openRightPanel();
    hideLeftPanel();
  };

  const onItemSelected = (data) => {

    setFlightInformation(data);
    openLeftPanel();
  }

  const onFilterChanged = (data) => {
    console.log(data)
    // setFilterInfo(data);
    filterInfo = data;
    initMap();
    fetchAndDrawRoute();
  }

  return (
    <>

      <div className='container1 container-main'>
        <div className='map-panel-top map-panel-slidedown' id="pnlTop">
          {/* Render Dashboard and pass the dashboardData as a prop */}
          {<Dashboard dashboardData={dashboardData} />}
        </div>

        <small>{ConfigSettings.GeneralSettings.MapToolTip}</small>


        <div className='map-container'>

          <div className='map-panel map-panel-left map-panel-slideright-hide d-none' id="pnlLeft">
            <FlightDetails flightInformation={flightInformation}></FlightDetails>
          </div>
          <button onClick={() => {
            openRightPanel();
          }} className='btn btn-primary pull-right map-right-open-btn'>{'<'}</button>
          <div id="map" title={ConfigSettings.GeneralSettings.MapToolTip}></div>

          <div className='map-panel map-panel-right map-panel-slideleft-hide d-none' id="pnlRight">
            <SearchResults selectedRoute={selectedRoute} onItemSelected={onItemSelected} onFilterChanged={onFilterChanged}></SearchResults>
          </div>
        </div>

      </div>
    </>
  );
};

export default MapWithAirRoute;
